import React from 'react';
import { motion } from 'framer-motion';

const LoadingScreen = () => {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8, ease: "easeInOut" }}
      style={{
        position: 'fixed',

        top: '-200px',
        bottom: '-200px',
        left: '0',
        right: '0',
        transform: 'none !important',

        backgroundColor: '#1a1a1a', // サイトの雰囲気に合わせた暗い色
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        color: 'white',
        fontFamily: '"Zen Maru Gothic", sans-serif',

      }}
    >
      {/* ここにお好みのアニメーション（ロゴや花びらの回転など）を配置 */}
      <div className="spinner"></div>

      <motion.div
        animate={{ 
          opacity: [0.5, 1, 0.5] 
        }}
        transition={{ repeat: Infinity, duration: 2 }}
        style={{ fontSize: '24px', letterSpacing: '0.2em' ,paddingTop:'50px'}}
      >
        Loading...
      </motion.div>
      
    </motion.div>
  );
};

export default LoadingScreen;